import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

export type ResourceText =
  | string
  | number
  | (() => React.ReactNode)
  | null
  | undefined;

export function printRes(jsx: ResourceText): React.ReactNode {
  if (!jsx) return null;
  if (typeof jsx === "string" || typeof jsx === "number") return jsx;
  return jsx();
}

export function useTypedResource<TResource>(
  path: string,
  defaultResource: TResource | null = null
): TResource {
  const { t, i18n } = useTranslation();
  const [resource, setResource] = useState<TResource>(
    () => t(path, { returnObjects: true }) as TResource
  );

  useEffect(() => {
    const update = () =>
      setResource(t(path, { returnObjects: true }) as TResource);
    i18n.on("languageChanged", update);
    update();
    return () => {
      i18n.off("languageChanged", update);
    };
  }, [path, t, i18n]);

  if (defaultResource) {
    return { ...(defaultResource as any), ...(resource as any) } as TResource;
  }
  return resource;
}
